import { useMemo } from 'react';
import styled from 'styled-components';

import { SummaryAttachment, SummaryContentType } from 'models/aiArtifacts/Summary';
import colors from 'styles/theme/colors';

import Section from '../Section';

function SummaryContent({ content }: { content: SummaryContentType | SummaryContentType[] }) {
  const contentItems = useMemo(
    () =>
      (!Array.isArray(content) ? [content] : content)?.filter((child) => child.text && child.text.trim().length > 0),
    [content]
  );

  return (
    <SummaryContentList>
      {contentItems.map((item, idx) => (
        <SummaryContentItem key={`${item.text}-${idx}`}>
          {item.text}
          {item.children && <SummaryContent content={item.children} />}
        </SummaryContentItem>
      ))}
    </SummaryContentList>
  );
}

type SummarySectionProps = {
  title: string;
  attachments: SummaryAttachment[];
  content: SummaryContentType | SummaryContentType[];
};

export default function SummarySection({ title, attachments, content }: SummarySectionProps) {
  return (
    <Section title={title} attachments={attachments}>
      <SummaryContent content={content} />
    </Section>
  );
}

const SummaryContentItem = styled.li`
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.2px;
  color: ${colors.black};
  white-space: pre-line;
`;

const SummaryContentList = styled.ul`
  list-style: disc;
  padding-left: 20px;
`;
